import { useState as useReactState } from "react";

// eslint-disable-next-line functional/prefer-tacit
export function useState<T>(is: T) {
  return useReactState(is);
}
